const mutations = {
  /*----------------------
  / General
  ----------------------*/
  setPackages(state, payload) {
    state.packages = payload.map(pkg => {
      pkg.units = pkg.units.data;
      pkg.roles = pkg.roles.data;
      return pkg;
    });
  },
  addPackage(state, payload) {
    state.packages.push(payload);
  },
  updatePackages(state, payload) {
    let index = state.packages.findIndex(item => {
      return item.id === payload.id;
    });
    Object.keys(payload).map(key => {
      if (key !== 'units') {
        state.packages[index][key] = payload[key];
      } else {
        state.packages[index].units = payload.units.slice();
      }
    });
  },
  deletePackage(state, payload) {
    state.packages = state.packages.filter(pkg => {
      return pkg.id !== payload;
    });
  },
  /*----------------------
  / Package
  ----------------------*/
  setPackageID(state, payload) {
    state.pkg.id = payload;
  },
  setPackage(state, payload) {
    payload.units = undefined;
    payload.roles = undefined;
    state.pkg = payload;
  },
  setRoles(state, payload) {
    state.roles = payload.roles.data;
  },
  /*----------------------
  / Units
  ----------------------*/
  setUnits(state, payload) {
    state.units = payload.units.data;
  },
  deleteUnit(state, payload) {
    state.units = state.units.filter(unit => {
      return unit.id !== payload;
    });
  },
  /*----------------------
  / Quotas
  ----------------------*/
  setQuotas(state, payload) {
    state.quotas = payload;
  },
  deleteQuota(state, payload) {
    state.quotas = state.quotas.filter(quota => {
      return quota.id !== payload;
    });
  },
};

export default mutations;
